export const isInIframe = () => {
  try {
    if (typeof window !== 'undefined') {
      return window.self !== window.top;
    }
  } catch (e) {}

  return false;
};
